"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransactions = fetchTransactions;
const client_js_1 = require("../client.js");
async function fetchTransactions(params) {
    let transactionBlocks = [];
    const suiClient = (0, client_js_1.getSuiClient)();
    const options = params.options
        ? params.options
        : {
            showEffects: true,
            showInput: true,
            showObjectChanges: true,
        };
    if (params.startTime >= params.endTime)
        throw new Error("startTime must be less than endTime");
    for (const filter of params.filter) {
        let hasNextPage = true;
        let nextCursor = null;
        while (hasNextPage) {
            const res = await suiClient.queryTransactionBlocks({
                cursor: nextCursor,
                filter: filter,
                options,
            });
            if (res.data.length !== 0) {
                const lastTx = res.data[res.data.length - 1];
                const firstTx = res.data[0];
                const laterTime = firstTx.timestampMs;
                const earlierTime = lastTx.timestampMs;
                if (Number(laterTime) < params.startTime) {
                    // Page beyond interval
                    hasNextPage = false;
                    break;
                }
                else if (Number(earlierTime) > params.endTime) {
                    // Page beyond interval
                    hasNextPage = res.hasNextPage;
                    nextCursor = res.nextCursor;
                    continue;
                }
                else {
                    // page is partially or completely in the interval
                    for (let i = 0; i < res.data.length; i++) {
                        if (Number(res.data[i].timestampMs) > params.startTime &&
                            Number(res.data[i].timestampMs) < params.endTime) {
                            transactionBlocks.push(res.data[i]);
                        }
                    }
                    hasNextPage = res.hasNextPage;
                    nextCursor = res.nextCursor;
                }
            }
            else {
                // Empty result
                transactionBlocks = transactionBlocks.concat(res.data);
                hasNextPage = res.hasNextPage;
                nextCursor = res.nextCursor;
            }
        }
    }
    return transactionBlocks;
}
//# sourceMappingURL=fetchTransactions.js.map